import { HOTJAR_SITE_ID, HOTJAR_VERSION } from '@/constants/hotjar';
import { Hotjar } from '@/services/Hotjar';
import { TrackingService } from '@/services/TrackingService';
import { isProduction } from '@treyd-io/core/constants/api';
import LogRocket from 'logrocket';
import { useEffect } from 'react';

export const useAnalytics = () => {
  useEffect(() => {
    if (!isProduction) return;

    Hotjar.init(HOTJAR_SITE_ID, HOTJAR_VERSION);

    const tracking = new TrackingService();
    tracking.init();

    LogRocket.init('awf8i4/treyd', {
      release: process.env.NEXT_PUBLIC_APP_VERSION,
    });
  }, []);
};
